export default __webpack_public_path__ + "static/media/Path -3.f2d4a096.png";